export default __webpack_public_path__ + "static/media/vsc.c52ee636.svg";